module.exports = __webpack_public_path__ + "img/3-import.7ece023c.png";